import type { StageParameters } from '../../stage/stage-parameters';

export type OpGraphQLEndpointEnvSetting = ReturnType<typeof getOpGraphQLEndpoint>;

export const getOpGraphQLEndpoint = (
  { baseUrl }: StageParameters,
): string => `${baseUrl}op-api/graphql`;
